const moveTitleAndDiscrOnMobile = () => {
  const buidler = document.querySelector('#product-builder');
  const previewAside = buidler.querySelector('.cpb-preview-aside');
  const productTitle = buidler.querySelector('.cpb-product-title');
  const productDiscr = buidler.querySelector('.cpb-product-description');
  const panelsContainer = buidler.querySelector('.cpb-panels-container');
  const productActions = buidler.querySelector('.cpb-product-actions');
  
  if (innerWidth > 999) {
    panelsContainer.prepend(productDiscr);
    panelsContainer.prepend(productTitle);
  } else {
    previewAside.prepend(productTitle);
    productActions.append(productDiscr);
  }
}
const swipeViews = () => {

  const previewWrapper = document.querySelector('.cpb-preview-wrapper');
  const nextArrow = document.querySelector('.cpb-preview-arrows-item.cpb-preview-arrows-right');
  const prevArrow = document.querySelector('.cpb-preview-arrows-item.cpb-preview-arrows-left');
  
  previewWrapper.addEventListener('touchstart', handleTouchStart, false);        
  previewWrapper.addEventListener('touchmove', handleTouchMove, false);
  previewWrapper.closest('#product-builder').dataset.customSwipe = 'true';
  
  var xDown = null;                                                        
  var yDown = null;
  
  function getTouches(evt) {
    return evt.touches
  }                                                     
                                                                           
  function handleTouchStart(evt) {
      const firstTouch = getTouches(evt)[0];                                      
      xDown = firstTouch.clientX;                                      
      yDown = firstTouch.clientY;                                      
  };                                                
                                                                           
  function handleTouchMove(evt) {
      if ( ! xDown || ! yDown ) {
          return;
      }
  
      var xUp = evt.touches[0].clientX;                                    
      var yUp = evt.touches[0].clientY;
  
      var xDiff = xDown - xUp;
      var yDiff = yDown - yUp;
                                                                           
      if ( Math.abs( xDiff ) > Math.abs( yDiff ) ) {
          if ( xDiff > 0 ) {
              nextArrow.click();
          } else {
              prevArrow.click();     
          }                       
      }
      xDown = null;
      yDown = null;                                             
  };
}

const customCodeInit = () => {
  moveTitleAndDiscrOnMobile();
  addEventListener('resize', moveTitleAndDiscrOnMobile);

  swipeViews();
}


document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', customCodeInit);